<!--
  @Description: 我的关注-机构-没有数据
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div class="nodata">
    <div class="default-container">
      <img :src="$store.state.static_img_url + 'pic/quesheng-2.png'">
      <p>暂无关注<br />以下是为您推荐的值得关注的机构<br />如已关注，请<a @click="$parent.getSubscribeList()">刷新看看</a>
      </p>
    </div>
    <div class="default-atten">
      <div class="recommend-list">
        <entity-temp :position="4" v-for="item,index in $parent.org_reco_list" :key="index" :item="item" :entitytype="1"></entity-temp>
      </div>
    </div>
  </div>
</template>
<script>
import EntityTemp from './EntityTemp'
import { recommend } from '@/service'
export default {
  components: {
    EntityTemp
  },
  created() {
    
  },
  mounted() { },
  data() {
    return {
      reco_list: []
    }
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>
<style lang="stylus" scoped>
</style>